export default __webpack_public_path__ + "svg/CompaniesLogos/logo_sisteplant.svg?ca4ded40";